import { styled, Box } from '@mui/material'

export const Content = styled(Box, { name: 'Content' })({
  justifyContent: 'space-between',
  alignItems: 'center',
  position: 'relative',
  flexGrow: 1,
  display: 'flex',
})
